import posthog from 'posthog-js';
import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment';
import { analyticsOptOut } from '../utils/privacy';

export const trackChangeSort = (sortType, context = 'requests_page') => {
  if (analyticsOptOut.hasOptedOut()) return;
  
  const eventData = {
    sort_type: sortType,
    context: context,
    ...getEnvironmentData()
  };

  posthog.capture('change_sort', eventData);
  track('change_sort', eventData);
  
  // Add TikTok tracking
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track('ViewContent', {
      content_name: 'sort_change',
      content_type: 'product',
      content_id: `sort_${sortType}`
    });
  }
}; 